<template>
    <div>
        <!--Toda la navbar, esta x pruebas el div -->
        <v-container class="pb-0 mb-1">
            <v-row align="center" justify="center" class="pa-0 ma-0">
                <v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
                    <v-img
                        src="img/logos/logo-nombre-ciafarma.png"
                        style="cursor: pointer;"
                        max-width="310px"
                        @click="toHome()"
                    />
                </v-col>
                <v-col
                    cols="12"
                    xl="6"
                    lg="6"
                    md="6"
                    sm="6"
                    xs="12"
                    align="end"
                    justify="center"
                    class="pa-0 ma-0 color"
                >
                    <!--Not logged-->
                    <LoginNavbar v-if="!isLoggedIn" />
                    <!-- Logged-->
                    <v-menu v-if="isLoggedIn" offset-y>
                        <template
                            v-slot:activator="{
                                on
                            }"
                        >
                            <div class="d-flex flex-row-reverse" align="end">
                                <router-link to="Carrito">
                                    <v-icon color="azul" size="25" class="mx-2">
                                        mdi-cart
                                    </v-icon>
                                </router-link>
                                <p>
                                    Productos:
                                    {{ cartCount }}
                                </p>
                            </div>
                            <v-btn
                                id="username"
                                text
                                style="cursor: pointer;"
                                color="azul"
                                v-on="on"
                            >
                                <v-icon color="azul" size="15" class="mx-2">
                                    mdi-account
                                </v-icon>
                                {{ user.nombre }}
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                v-for="(item, $index) in menuUsuario"
                                :key="$index"
                                @click="goTo(item)"
                            >
                                <v-list-item-title>
                                    {{ item.label }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
        </v-container>
        <v-divider />
        <v-tabs
            v-model="tabSelect"
            centered
            class="elevation-1 mt-2 mb-0 pb-0"
            background-color="white"
            slider-color="azul"
            color="azul"
            max-width="100%"
        >
            <v-tab
                v-for="(item, index) in menu"
                :key="index"
                class="px-2"
                @click="goTo(item)"
            >
                <v-icon v-if="item.icon" color="azul" class="mx-2">
                    {{ item.icon }}
                </v-icon>
                {{ item.label }}
            </v-tab>
        </v-tabs>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import LoginNavbar from './LoginNavbar';

export default {
    components: { LoginNavbar },
    data: () => ({
        tabSelect: 0,
        tabs: [
            {
                label: 'Inicio',
                icon: 'home',
                routerName: 'Home'
            },
            {
                label: 'Contacto',
                icon: 'person',
                routerName: 'Contact'
            },
            {
                label: 'Acerca de Nosotros',
                icon: 'book',
                routerName: 'About'
            },
            {
                label: 'Productos',
                icon: 'shopping_cart',
                routerName: 'Productos',
                requiresAuth: true
            },
            {
                label: 'Ofertas',
                icon: 'shop',
                routerName: 'Ofertas',
                requiresAuth: true
            },
            {
                label: 'Pedidos',
                icon: 'mdi-shopping',
                routerName: 'Pedidos',
                requiresAuth: true
            }
        ],
        menuUsuario: [
            // { label: "Cambiar Contraseña", icono: "", routerName: "changePassword" },
            {
                label: 'Cerrar Sesión',
                icon: '',
                function: 'singOff'
            }
        ]
    }),

    computed: {
        ...mapGetters(['isLoggedIn']),
        ...mapGetters('products', ['cartCount']),
        ...mapState('auth', ['user']),

        menu() {
            if (this.isLoggedIn) {
                return this.tabs;
            }
            const tabs = this.tabs.filter(tab => !tab.requiresAuth);
            return tabs;
        }
    },

    watch: {
        $route(val) {
            const { name } = val;
            this.tabSelect = this.tabs.findIndex(
                tab => tab.routerName === name
            );
        }
    },
    methods: {
        ...mapActions('auth', ['signOut']),
        ...mapMutations('products', ['CLEAR_CART']),

        toHome() {
            this.$router.push({
                name: 'Home'
            });
            this.tabSelect = 0;
        },
        singOff() {
            this.CLEAR_CART();
            this.signOut();
            this.$router.push('/');
            this.toHome();
        },
        goTo(menu) {
            if (typeof menu.function === 'undefined') {
                this.$router.push({
                    name: menu.routerName
                });
            } else {
                this[menu.function]();
            }
        }
    }
};
</script>
<style scoped>
.color {
    color: #184087;
}
</style>
